document.addEventListener('DOMContentLoaded',()=>{
// Kalkulačka m² → balenia
document.querySelectorAll('[data-calc]').forEach(c=>{
  const pack=parseFloat(c.dataset.pack)||1, pcs=parseInt(c.dataset.pcs)||0, price=parseFloat(c.dataset.price)||0; // price = cena balenia v centoch
  const height = parseFloat(c.dataset.height);
  const width = parseFloat(c.dataset.width);
  const m2=c.querySelector('[data-m2]'), res=c.querySelector('[data-reserve]');
  const out={packs:c.querySelector('[data-out=packs]'),pcs:c.querySelector('[data-out=pcs]'),area:c.querySelector('[data-out=area]'),total:c.querySelector('[data-out=total]')};
  const qty=document.querySelector('[data-qty-input]'), btn=document.querySelector('[data-add-label]');
  const fmt=n=>(n/100).toFixed(2).replace('.',',')+'€';

  // nový helper: bezpečné parsování čísla i s čárkou jako oddělovačem desetin
  const parseNum=v=>{
    const n=parseFloat(String(v).replace(',','.'));
    return isNaN(n) ? 0 : n;
  };

  const run=()=>{
    // minimální plocha 0,1 m² místo 1 m², aby prošly i malé hodnoty jako 0,5
    const raw=parseNum(m2.value);
    const area=Math.max(0.1, raw>0?raw:0.1)*(res&&res.checked?1.1:1);
    const packs=Math.max(1,Math.ceil(area/pack));
    const width_converted = width / 100
    const height_converted = height / 100
    out.packs.textContent=packs+' bal.'; 
    //out.pcs.textContent=(packs*pcs)+' ks dlaždíc';
    console.log(width_converted, height_converted);
    if ( isNaN(width_converted) != true || isNaN(height_converted)!=true) out.pcs.textContent=(parseInt(out.packs.textContent)*Math.round(pack/(width_converted*height_converted)) + " ks dlaždíc")
    out.area.textContent=(packs*pack).toFixed(2).replace('.',',')+' m²'; out.total.textContent=fmt(packs*price);
    if(qty) qty.value=packs; if(btn) btn.textContent='Pridať '+out.area.textContent+' do košíka'
  };
  const stepM2=dir=>{
    const step=parseFloat(m2.step)||0.5, cur=parseNum(m2.value);
    const next=Math.max(0, Math.round((cur+dir*step)/step)*step);
    m2.value=+next.toFixed(2);
    run();
  };
  const mm=c.querySelector('[data-m2-minus]'), mp=c.querySelector('[data-m2-plus]');
  mm&&mm.addEventListener('click',()=>stepM2(-1));
  mp&&mp.addEventListener('click',()=>stepM2(1));
  m2&&m2.addEventListener('input',run); res&&res.addEventListener('change',run); run();
});
  // Galéria – prepínanie obrázkov
  document.querySelectorAll('[data-thumb]').forEach(b=>b.addEventListener('click',()=>{
    const slides=document.querySelectorAll('[data-slide]'); if(!slides.length) return;
    slides.forEach((s,i)=>{
      const on=i===+b.dataset.index; s.hidden=!on;
      if(!on){ s.querySelectorAll('video').forEach(v=>v.pause()); s.querySelectorAll('iframe').forEach(f=>{const src=f.src; f.src=src;}); }
    });
    b.parentElement.querySelectorAll('button').forEach(x=>x.removeAttribute('aria-current')); b.setAttribute('aria-current','true');
  }));
  // Filtre – odoslať pri zmene
  // Dvojitý posuvník ceny – hodnoty sa posielajú len keď sú mimo krajných hodnôt
  document.querySelectorAll('[data-range]').forEach(r=>{
    // Režim "values": filter je zoznam presných hodnôt – posuvník vyberie všetky hodnoty v rozsahu
    const nums=s=>(s||'').split(',').map(parseFloat).filter(n=>!isNaN(n));
    const vals=nums(r.dataset.values).sort((p,q)=>p-q), act=nums(r.dataset.active).sort((p,q)=>p-q);
    const byValues=!!r.dataset.param;
    const lo=byValues?Math.floor(vals[0]):+r.dataset.lo, hi=byValues?Math.ceil(vals[vals.length-1]):+r.dataset.hi;
    const a=r.querySelector('[data-range-min]'), b=r.querySelector('[data-range-max]');
    const outA=r.querySelector('[data-range-min-out]'), outB=r.querySelector('[data-range-max-out]');
    const fill=r.querySelector('[data-range-fill]');
    if(byValues){
      if(!vals.length){ r.hidden=true; return; }
      [a,b].forEach(i=>{i.min=lo;i.max=hi});
      a.value=act.length?Math.floor(act[0]):lo; b.value=act.length?Math.ceil(act[act.length-1]):hi;
    }
    const upd=e=>{
      let x=+a.value, y=+b.value;
      if(x>y){ if(e&&e.target===a){x=y;a.value=x} else {y=x;b.value=y} }
      const span=(hi-lo)||1;
      fill.style.left=((x-lo)/span*100)+'%'; fill.style.right=((hi-y)/span*100)+'%';
      r.querySelector('[data-range-from]').textContent=x; r.querySelector('[data-range-to]').textContent=y;
      if(byValues){
        r.querySelectorAll('[data-gen]').forEach(n=>n.remove());
        if(x>lo||y<hi) vals.filter(v=>v>=x&&v<=y).forEach(v=>{
          const h=document.createElement('input'); h.type='hidden'; h.name=r.dataset.param; h.value=v; h.dataset.gen=''; r.appendChild(h);
        });
      } else {
        outA.value=x; outA.disabled=x<=lo;
        outB.value=y; outB.disabled=y>=hi;
      }
    };
    a.addEventListener('input',upd); b.addEventListener('input',upd); upd();
  });
  document.querySelectorAll('[data-facets]').forEach(f=>{
    let sent=false;
    f.addEventListener('change',()=>{ if(sent) return; sent=true; f.submit(); });
  });
});

  // Kusové produkty – qty box s plus/minus, syncováno se skrytým quantity poľom formulára
  document.querySelectorAll('[data-qty-box]').forEach(box=>{
    const visible=box.querySelector('[data-qty-visible]');
    if(!visible) return;
    const hidden=document.querySelector('[data-qty-input]'); // skryté pole formulára (name="quantity")
    const min=parseInt(visible.min)||1;
    const max=visible.max?parseInt(visible.max):Infinity;
    const step=parseInt(visible.step)||1;
    const minus=box.querySelector('[data-qty-minus]');
    const plus=box.querySelector('[data-qty-plus]');
    const btn=document.querySelector('[data-add-label]');

    const clamp=v=>Math.min(max,Math.max(min,v));
    const setVal=v=>{
      const val=clamp(v);
      visible.value=val;
      if(hidden) hidden.value=val;
      minus&&minus.toggleAttribute('disabled', val<=min);
      plus&&plus.toggleAttribute('disabled', val>=max);
      if(btn) btn.textContent = val>1 ? 'Pridať '+val+' ks do košíka' : 'Pridať do košíka';
    };

    minus&&minus.addEventListener('click',()=>setVal((parseInt(visible.value)||min)-step));
    plus&&plus.addEventListener('click',()=>setVal((parseInt(visible.value)||min)+step));
    visible.addEventListener('change',()=>setVal(parseInt(visible.value)||min));
    visible.addEventListener('blur',()=>setVal(parseInt(visible.value)||min));
    setVal(parseInt(visible.value)||min);
  });

  // Košík – plus/minus pri množstve
  document.querySelectorAll('.cart-line__qty').forEach(row=>{
    const input=row.querySelector('input[type=number]');
    if(!input) return;
    const step=dir=>{
      const min=parseInt(input.min)||0;
      input.value=Math.max(min,(parseInt(input.value)||0)+dir);
      input.dispatchEvent(new Event('change',{bubbles:true}));
    };
    const mm=row.querySelector('[data-cart-minus]'), mp=row.querySelector('[data-cart-plus]');
    mm&&mm.addEventListener('click',()=>step(-1));
    mp&&mp.addEventListener('click',()=>step(1));
  });

  // Balenia bez kalkulačky – jednoduchý počet, syncováno so skrytým quantity poľom
  document.querySelectorAll('[data-qty-simple]').forEach(input=>{
    const hidden=document.querySelector('[data-qty-input]');
    const btn=document.querySelector('[data-add-label]');
    const sync=()=>{
      const val=Math.max(1,parseInt(input.value)||1);
      if(hidden) hidden.value=val;
      if(btn) btn.textContent = val>1 ? 'Pridať '+val+' balení do košíka' : 'Pridať do košíka';
    };
    input.addEventListener('input',sync);
    sync();
  });